//Solar Report
//Site Details
//Date Slicer - vwReportingDateTime - Date
//Array Details
//Date Slicer - vwReportingDateTime - Date
//End Use Slicer - vwEndUseNames - EndUseName
//Inverters
//Date Slicer - vwReportingDateTime - Date
//End Use Slicer - vwEndUseNames - EndUseName
//Inverter Slicer - vwEndUseNames - EndUseName

import * as powerbi from 'powerbi-client';
import slicer from '../slicerReports/solarSlicer';

const PAGE_INVERTERS = 'Inverters';

let report = null;
let config = null;

// Embed a Power BI report in the given HTML element with the given configurations
// Read more about how to embed a Power BI report in your application here: https://go.microsoft.com/fwlink/?linkid=2153590
const getEmbed = async (container, configuration) => {
  config = configuration;
  /*-----------------------------------------------------------------------------------+
  |    Don't change these values here: access token, embed URL and report ID.          |
  |    To make changes to these values:                                                |
  |    1. Save any other code changes to a text editor, as these will be lost.         |
  |    2. Select 'Start over' from the ribbon.                                         |
  |    3. Select a report or use an embed token.                                       |
  +-----------------------------------------------------------------------------------*/
  // Embed the report and display it within the div container.
  const pbi = new powerbi.service.Service(
    powerbi.factories.hpmFactory,
    powerbi.factories.wpmpFactory,
    powerbi.factories.routerFactory
  );

  report = pbi.embed(container, configuration);

  // report.on will add an event handler
  report.on('loaded', async () => {
    try {
      const activePage = await getActivePage(report);
      const visuals = await activePage.getVisuals();

      await slicer.setSlicersForPage(
        activePage.displayName,
        config.reportParameters,
        visuals
      );
      report.off('loaded');
    } catch (errors) {
      return Promise.reject(errors);
    }
  });

  //report.off removes all event handlers for a specific event
  // clears the event handlers before starting the event listener
  report.off('dataSelected');

  // report.on start the event listener
  report.on('dataSelected', async (event) => {
    const data = event.detail;

    // filter events for only slicers
    if (data.visual.type !== 'slicer') return;

    try {
      const activePage = await getActivePage(report);
      const newValue = data.dataPoints?.[0]?.identity?.[0]?.equals;

      if (!newValue) return;

      if (
        data.visual.title === 'End Use Slicer' &&
        activePage.displayName === PAGE_INVERTERS
      ) {
        slicer.onInverterTopEndUseChanged(newValue);

        const visuals = await activePage.getVisuals();
        const inverterData = slicer.getInverterDataByTopEndUseName(
          config.reportParameters,
          newValue
        );

        await slicer.setInverterSlicerVisual(
          visuals,
          inverterData?.InverterEndUseName
        );
      }
    } catch (errors) {
      return Promise.reject(errors);
    }
  });

  // Keep the Date Slicer selection in sync across pages: whenever the report
  // re-renders (including after the user changes the Date Slicer), read its
  // current state back into the shared report parameters.
  report.on('rendered', async () => {
    try {
      const activePage = await getActivePage(report);
      const visuals = await activePage.getVisuals();
      const dateSlicerVisual = visuals.find(
        (visual) => visual.type === 'slicer' && visual.title === 'Date Slicer'
      );

      if (!dateSlicerVisual) return;

      const state = await dateSlicerVisual.getSlicerState();
      const conditions = state?.filters?.[0]?.conditions;

      if (!conditions || conditions.length < 2) return;

      config.reportParameters.StartDate = conditions[0].value;
      config.reportParameters.EndDate = conditions[1].value;
    } catch (errors) {
      return Promise.reject(errors);
    }
  });

  report.on('pageChanged', async () => {
    try {
      const activePage = await getActivePage(report);
      const visuals = await activePage.getVisuals();

      await slicer.setSlicersForPage(
        activePage.displayName,
        config.reportParameters,
        visuals
      );
    } catch (errors) {
      return Promise.reject(errors);
    }
  });

  return report;
};

const getActivePage = async (report) => {
  const pages = await report.getPages();
  return pages.filter((page) => page.isActive)[0];
};

// Refresh the report
export const refreshSolarData = async () => {
  try {
    await report.refresh();
    return Promise.resolve();
  } catch (errors) {
    return Promise.reject(errors);
  }
};

export default {
  getEmbed,
};
